export default __webpack_public_path__ + "static/media/comment-emote-laugh.078ac7d2.svg";